// extracted by mini-css-extract-plugin
export default {"tab":"navbar_tab__5Qpwo","tabs":"navbar_tabs__f7DuE"};